"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
NewPasswordController.$inject = ['$scope', 'auth', '$window', '$state', 'api', 'notify', '$location'];
function NewPasswordController($scope, auth, $window, $state, api, notify, $location) {
    var token = auth.getToken();
    $scope.data = {};
    $scope.loading = false;
    if (!_.isEmpty(token)) {
        $state.go('home');
    }
    $scope.exit = function () {
        $window.location.replace('/');
    };
    $scope.params = $location.search();
    if (!$scope.params.selector || !$scope.params.validator) {
        $scope.exit();
    }
    else {
        $scope.data.selector = $scope.params.selector;
        $scope.data.validator = $scope.params.validator;
    }
    $scope.save = function () {
        $scope.loading = true;
        api.post('/renew-password', $scope.data)
            .then(function (response) {
            $scope.loading = false;
            notify.success(response);
            $scope.exit();
        }, function (error) {
            $scope.loading = false;
            console.log(error);
            notify.error(error.data);
        });
    };
}
exports.NewPasswordController = NewPasswordController;



//////////////////
// WEBPACK FOOTER
// ./scripts/core/password_reset/controllers/NewPasswordController.js
// module id = 334
// module chunks = 0